module.exports = __webpack_public_path__ + "img/Social_text02c_understand.73cb4b72.png";